import React, { useState, useEffect } from 'react';
import apiClient from '../api/apiClient';
import { useAuth } from '../context/AuthContext';
import { ROLES } from '../utils/roles';
import TerminSelector from '../components/TerminSelector';
import { downloadCSV } from '../utils/csvExport';
import './StaffPage.css';

const OutgoingAllocationPage = () => {
  const { user } = useAuth();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentTerminId, setCurrentTerminId] = useState(null); // State til termin

  // Kører hver gang termin eller bruger ændres
  useEffect(() => {
    if (user && currentTerminId) {
      fetchData();
    }
  }, [user, currentTerminId]);

  const fetchData = async () => {
    setLoading(true);
    try {
      let url = `/api/allocation/outgoing?termin_id=${currentTerminId}`; // Send termin med
      
      if (user.role === ROLES.SC_ADMIN && user.scId) {
         url += `&scId=${user.scId}`;
      }

      const res = await apiClient.get(url);
      setList(res.data);
    } catch (err) { console.error(err); }
    setLoading(false);
  };

  const handleDownload = () => {
    if (list.length === 0) return alert('Ingen data at hente');

    // Definer kolonner til CSV
    const fields = [
      { label: 'Fornavn', value: 'fornavn' },
      { label: 'Efternavn', value: 'efternavn' },
      { label: 'Skal til', value: 'target_sc_name' }, // Navnet på kolonnen fra SQL
      { label: 'Prøve', value: 'prøve' },
      { label: 'Type', value: 'type' },
      { label: 'Antal Hold', value: 'hold_count' },
      { label: 'Antal Kursister', value: 'elev_count' }
    ];

    const filename = `Udgående_Censorer_${new Date().toISOString().slice(0,10)}`;
    downloadCSV(list, fields, filename);
  };

  return (
    <div>
      <div className="table-card" style={{
        marginBottom: '20px', background: 'transparent', boxShadow: 'none', padding: 0,
        display: 'flex', justifyContent: 'space-between', alignItems: 'center'
      }}>
         <TerminSelector onTerminChange={(id) => setCurrentTerminId(id)} />
         
         {/* Download Knap */}
         <button 
            onClick={handleDownload}
            style={{
              backgroundColor: '#28a745', color: 'white', border: 'none', 
              padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold',
              display: 'flex', alignItems: 'center', gap: '8px', boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
            }}
         >
           Download CSV
         </button>
      </div>

      <div className="table-card">
        {loading ? <p>Henter data...</p> : (
          <table className="censor-table">
            <thead>
              <tr>
                <th>Censor</th>
                <th>Skal til (Sprogcenter)</th>
                <th>Prøve</th>
                <th>Type</th>
                <th>Antal Opgaver</th>
              </tr>
            </thead>
            <tbody>
              {list.map((row, idx) => (
                <tr key={idx}>
                  <td><strong>{row.fornavn} {row.efternavn}</strong></td>
                  <td><span style={{color: '#003366'}}>{row.target_sc_name}</span></td>
                  <td>{row.prøve}</td>
                  <td>
                    <span className={`role-badge ${row.type === 'Mundtlig' ? 'censor-badge' : 'teacher-badge'}`}>
                      {row.type}
                    </span>
                  </td>
                  <td style={{fontWeight: 'bold', fontSize: '1.1rem'}}>
                    {row.elev_count || 0}
                  </td>
                </tr>
              ))}
              {list.length === 0 && !loading && <tr><td colSpan="5" style={{textAlign:'center', padding:'20px'}}>Ingen udgående opgaver fundet for denne termin.</td></tr>}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default OutgoingAllocationPage;